<template>
  <div>
    <div class="writeBox writeBox1">
      <div class="writeItem">
        <label>签约公司</label>
        <el-select class="input" v-model="editData.company" placeholder="请选择签约公司" size='mini' filterable :disabled="isEditable ? false : true">
          <el-option v-for="(item, index) in companyList" :key="index" :label="item.company" :value="item.company">
          </el-option>
        </el-select>
      </div>
      <div class="writeItem">
        <label>客户全称</label>
        <el-select class="input" v-model="editData.customer_name" size='mini' filterable placeholder="请选择客户全称">
          <el-option v-for="(item, index) in customerList" :key="index" :label="item.customer_name"
            :value="item.customer_name">
          </el-option>
        </el-select>
      </div>
      <div class="writeItem">
        <label>穿透最终客户全称</label>
        <el-input class="input" v-model="editData.final_customer_name" placeholder="请输入穿透最终客户全称" size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>投放平台</label>
        <el-select class="input" v-model="editData.launch_platform" placeholder="请选择投放平台" size='mini' filterable :disabled="isEditable ? false : true">
          <el-option v-for="(item, index) in platformList" :key="index" :label="item.platform_name"
            :value="item.platform_name">
          </el-option>
        </el-select>
      </div>
      <!-- <div class="writeItem">
                <label>媒体名称</label>
                <el-select class="input" v-model="editData.media_name" placeholder="请选择媒体名称" size='mini' filterable :disabled="isEditable ? false : true">
                    <el-option
                    v-for="(item,index) in mediaList"
                    :key="index"
                    :label="item.media_name"
                    :value="item.media_name">
                    </el-option>
                </el-select>
            </div> -->
      <div class="writeItem">
        <label>项目名称</label>
        <el-select class="input" v-model="editData.project_name" placeholder="请输入项目名称" size='mini' filterable :disabled="isEditable ? false : true">
          <el-option v-for="(item, index) in projectList" :key="index" :label="item.title" :value="item.title">
          </el-option>
        </el-select>
      </div>
      <div class="writeItem">
        <label>红人名称</label>
        <el-input class="input" v-model="editData.internet_celebrity_name" placeholder="请输入红人名称" size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <div class="writeItem">
        <label>红人ID</label>
        <el-input class="input" v-model="editData.internet_celebrity_id" placeholder="请输入红人ID" size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <div class="writeItem">
        <label>投放起始日期</label>
        <el-date-picker class="input" v-model="editData.launch_start_date" type="date" size="mini"
          value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期" :disabled="isEditable ? false : true">
        </el-date-picker>
      </div>
      <div class="writeItem">
        <label>投放截止日期</label>
        <el-date-picker class="input" v-model="editData.launch_end_date" type="date" size="mini" value-format="yyyy-MM-dd"
          :picker-options="pickerOptions" placeholder="选择日期" :disabled="isEditable ? false : true">
        </el-date-picker>
      </div>
      <div class="writeItem">
        <label>销售人员：</label>
        <el-select class="input" v-model="editData.salesman" size='mini' filterable placeholder="请选择" :disabled="isEditable ? false : true">
          <el-option v-for="(item, index) in saleList" :key="index" :label="item.real_name" :value="item.real_name">
          </el-option>
        </el-select>
      </div>
      <div class="writeItem">
        <label>订单金额</label>
        <!-- :disabled="isEditable ? (editData.status > 2 ? true : false) : true" -->
        <el-input
          class="input"
          :disabled="isEditable ? false : true"
          v-model="editData.amount"
          placeholder="请输入订单金额"
          @input="(val) => { clearNoNum({ value: val, valueName: 'amount', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>订单最终收入金额</label>
        <el-input class="input" v-model="editData.final_amount" placeholder="请输入订单最终收入金额"
          @input="(val) => { clearNoNum({ value: val, valueName: 'final_amount', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折前实际消耗</label>
        <!-- :disabled="isEditable ? (editData.status > 2 ? true : false) : true" -->
        <el-input
          class="input"
          :disabled="isEditable ? false : true"
          v-model="editData.actual_consumption_before" placeholder="请输入折前实际消耗"
          @input="(val) => { clearNoNum({ value: val, valueName: 'actual_consumption_before', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折后实际消耗</label>
        <el-input class="input" v-model="editData.actual_consumption_after" placeholder="请输入折后实际消耗"
          @input="(val) => { clearNoNum({ value: val, valueName: 'actual_consumption_after', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折前链接费</label>
        <!-- :disabled="isEditable ? (editData.status > 2 ? true : false) : true" -->
        <el-input
          class="input"
          :disabled="isEditable ? false : true"
          v-model="editData.link_fee_before"
          placeholder="请输入折前链接费"
          @input="(val) => { clearNoNum({ value: val, valueName: 'link_fee_before', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折后链接费</label>
        <el-input class="input" v-model="editData.link_fee_after" placeholder="请输入折后链接费"
          @input="(val) => { clearNoNum({ value: val, valueName: 'link_fee_after', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折前流量助推</label>
        <!-- :disabled="isEditable ? (editData.status > 2 ? true : false) : true" -->
        <el-input
          class="input"
          :disabled="isEditable ? false : true"
          v-model="editData.flow_boost_back_point_before" placeholder="请输入折前流量助推"
          @input="(val) => { clearNoNum({ value: val, valueName: 'flow_boost_back_point_before', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折后流量助推</label>
        <el-input class="input" v-model="editData.flow_boost_back_point_after" placeholder="请输入折后流量助推"
          @input="(val) => { clearNoNum({ value: val, valueName: 'flow_boost_back_point_after', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折前置顶费</label>
        <!-- :disabled="isEditable ? (editData.status > 2 ? true : false) : true" -->
        <el-input
          class="input"
          :disabled="isEditable ? false : true"
          v-model="editData.top_fee_before"
          placeholder="请输入折前置顶费"
          @input="(val) => { clearNoNum({ value: val, valueName: 'top_fee_before', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>折后置顶费</label>
        <el-input class="input" v-model="editData.top_fee_after" placeholder="请输入折后置顶费"
          @input="(val) => { clearNoNum({ value: val, valueName: 'top_fee_after', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>

      <div class="writeItem">
        <label>客户后返返点金额</label>
        <el-input class="input" v-model="editData.customer_rebate_amount" placeholder="请输入客户后返返点金额"
          @input="(val) => { clearNoNum({ value: val, valueName: 'customer_rebate_amount', mainName: 'editData' }) }"
          size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <div class="writeItem">
        <label>返点支出收款单位</label>
        <el-input class="input" v-model="editData.rebate_expense_receiving_unit" placeholder="请输入返点支出收款单位"
          size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <!-- <div class="writeItem">
        <label>是否对公</label>
        <el-checkbox v-model="editData.if_public">是</el-checkbox>
      </div> -->
      <div class="writeItem">
        <label>回款日期</label>
        <el-date-picker class="input" v-model="editData.payment_date" type="date" size="mini" value-format="yyyy-MM-dd"
          :picker-options="pickerOptions" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="writeItem">
        <label>开具红字发票日期</label>
        <el-date-picker class="input" v-model="editData.income_red_invoice_date" type="date" size="mini"
          value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="writeItem">
        <label>开具红字发票金额</label>
        <el-input class="input" v-model="editData.income_red_invoice_amount" placeholder="请输入开具红字发票金额"
          @input="(val) => { clearNoNum({ value: val, valueName: 'income_red_invoice_amount', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>cpa单量</label>
        <el-input class="input" v-model="editData.cpa_single_quantity" placeholder="请输入cpa单量"
          @input="(val) => { clearNoNum({ value: val, valueName: 'cpa_single_quantity', mainName: 'editData' }) }"
          size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>备注</label>
        <el-input class="input" v-model="editData.saler_note" placeholder="请输入备注" size='mini'></el-input>
      </div>
      <!-- 提交修改原因 -->
      <div class="writeBox" v-if="editData.status > 2">
        <p class="title">修改原因</p>
        <div class="writeItem" style="width:90%">
          <el-input class="input" type="textarea" v-model.trim="op_reason" placeholder="请输入修改原因" size='mini'></el-input>
        </div>
      </div>
    </div>
    <!-- button  -->
    <div class="buttones">
      <button class="yes" @click="orderUpdate()">{{ editData.status > 2 ? '提交审核' : '确定' }}</button>
      <button @click="orderCancelClick">取消</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['editDataTotal'],
  data () {
    // S 获取当前角色是否具备可编辑权限
    const isEditableRoleIds = [12]
    const currentRoleId = JSON.parse(this.$cookie.getCookie('userInfo') || '{}').role_id || 0
    const isEditable = isEditableRoleIds.includes(Number(currentRoleId))
    // E 获取当前角色是否具备可编辑权限

    return {
      pickerOptions: {
        // disabledDate(time) {
        //     return time.getTime() > Date.now();
        // },
      },
      editData: JSON.parse(JSON.stringify(this.editDataTotal)),
      platformList: [],
      mediaList: [],
      saleList: [],
      op_reason: '',
      companyList: [],
      customerList: [],
      projectList: [],
      isEditable: isEditable,
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.mediaListEvent();
    this.customerListEvent();
    this.getSaleList();
    this.signCompanyListEvent();
    this.platformListEvent();
    this.getProjectList()
  },
  methods: {
    clearNoNum ({ value, valueName, mainName }) {//判断只能输入纯数字或者小数点，及负整数
      var t = value.charAt(0);
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
      if (t == '-') {
        value = '-' + value;
      }
      if (mainName) {
        this[mainName][valueName] = value
      } else {
        this[valueName] = value
      }
    },
    orderCancelClick () {
      this.$emit('cancelToast')
    },
    orderUpdate () {//编辑订单
      if (this.editData.status > 2 && this.op_reason == '') {
        this.$message({
          message: '请输入修改原因！',
          type: 'warning'
        })
        return
      }
      if (this.editData.launch_end_date == '' || !this.editData.launch_end_date) {
        this.orderIcomeUpdate()
        return
      }
      if (new Date(this.editData.launch_end_date).getTime() < new Date(this.editDataTotal.month).getTime()) {
        this.$alert('投放日期小于所属月份，请确认是否为补录订单', '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
        }).then(() => {
          this.orderIcomeUpdate()
        }).catch(() => {
        });
      } else {
        this.orderIcomeUpdate()
      }
    },
    orderIcomeUpdate () {//提交
      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + this.URL.orderIcomeUpdate, {
        id: this.editData.id,
        customer_name: this.editData.customer_name,
        final_customer_name: this.editData.final_customer_name,
        launch_platform: this.editData.launch_platform,
        // media_name: this.editData.media_name,
        project_name: this.editData.project_name,
        internet_celebrity_name: this.editData.internet_celebrity_name,
        internet_celebrity_id: this.editData.internet_celebrity_id,
        launch_start_date: this.editData.launch_start_date,
        launch_end_date: this.editData.launch_end_date,
        salesman: this.editData.salesman,
        amount: this.editData.amount,
        final_amount: this.editData.final_amount,
        actual_consumption_before: this.editData.actual_consumption_before,
        link_fee_before: this.editData.link_fee_before,
        flow_boost_back_point_before: this.editData.flow_boost_back_point_before,
        top_fee_before: this.editData.top_fee_before,
        actual_consumption_after: this.editData.actual_consumption_after,
        link_fee_after: this.editData.link_fee_after,
        flow_boost_back_point_after: this.editData.flow_boost_back_point_after,
        top_fee_after: this.editData.top_fee_after,
        customer_rebate_amount: this.editData.customer_rebate_amount,
        rebate_expense_receiving_unit: this.editData.rebate_expense_receiving_unit,
        payment_date: this.editData.payment_date,
        income_red_invoice_date: this.editData.income_red_invoice_date,
        income_red_invoice_amount: this.editData.income_red_invoice_amount,
        cpa_single_quantity: this.editData.cpa_single_quantity,
        // if_public: this.editData.if_public ? 1 : 0,
        company: this.editData.company,
        saler_note: this.editData.saler_note,
        op_reason: this.editData.status > 2 ? this.op_reason : '',
        verify_edit: this.editData.status > 2 ? 1 : 0

      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.$alert('编辑成功！', '成功', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              this.$emit('emit_refresh')
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    platformListEvent () {//平台列表
      this.$axios.get(this.URL.BASEURL + this.URL.platformList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.platformList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    getProjectList () {//获取项目名称列表
      var paramsData = {
        page: 1,
        pagesize: 999,
      }
      this.$axios.get(this.URL.BASEURL + this.URL.projectIndex, {
        params: paramsData
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.projectList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    signCompanyListEvent () {//签约公司
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.companyList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    mediaListEvent () {//媒体列表
      var month = this.editData.month;
      if (!month || month == '') {
        return
      }
      var arr = month.split('');
      var ind = 0, selfIndex = arr.length;
      arr.forEach((item, index) => {
        if (item == '-') {
          ind += 1;
          if (ind == 2) {
            selfIndex = index;
          }
        }
      })
      month = month.slice(0, selfIndex)
      this.$axios.get(this.URL.BASEURL + this.URL.mediaListSelect, {
        params: {
          month: month
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.mediaList = res.rst;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    getSaleList () {
      this.$axios.get(this.URL.BASEURL + this.URL.users, {
        params: {
          page: 1,
          page_size: 999,
          role_id: 11
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          var arr = res.rst.data;
          this.saleList = arr.filter((v) => {
            return v.real_name
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    customerListEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.customerList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>@import "../medium/edit.scss";</style>


// WEBPACK FOOTER //
// src/components/Order/saler/incomeEdit.vue